export default __webpack_public_path__ + "static/media/delete-left.b688259a.svg";